<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/relatedLinks/edit">{{lang.LBL_ADD_RELATED_LINK}}</router-link></li>
        <li><router-link to="/modules/relatedLinks">{{lang.LBL_VIEW_RELATED_LINK}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/RelatedLinks/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
